var map = {
	"./img_0.png": 805,
	"./img_1.png": 806,
	"./img_10.png": 807,
	"./img_11.png": 808,
	"./img_2.png": 809,
	"./img_3.png": 810,
	"./img_4.png": 811,
	"./img_5.png": 812,
	"./img_6.png": 813,
	"./img_7.png": 814,
	"./img_8.png": 815,
	"./img_9.png": 816
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 804;